var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormBuildingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37792 4.60526V1.53509L4.78344 0L3.18896 1.53509V2.55848H0V9.72222H9.56689V4.60526H6.37792ZM2.12597 8.69883H1.06299V7.67544H2.12597V8.69883ZM2.12597 6.65205H1.06299V5.62865H2.12597V6.65205ZM2.12597 4.60526H1.06299V3.58187H2.12597V4.60526ZM5.31494 8.69883H4.25195V7.67544H5.31494V8.69883ZM5.31494 6.65205H4.25195V5.62865H5.31494V6.65205ZM5.31494 4.60526H4.25195V3.58187H5.31494V4.60526ZM5.31494 2.55848H4.25195V1.53509H5.31494V2.55848ZM8.5039 8.69883H7.44091V7.67544H8.5039V8.69883ZM8.5039 6.65205H7.44091V5.62865H8.5039V6.65205Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormBuildingIcon);
export default __webpack_public_path__ + "static/media/form-building-icon.67f9b958dfaa7a8260c8b916a2eb995f.svg";
export { ForwardRef as ReactComponent };